<template>
  <el-dialog
    title="退款信息"
    :visible.sync="dialogVisible"
    @opened="dialogOpen"
  >
    <el-form
      ref="form"
      :model="form"
      label-width="150px"
      size="small"
    >
      <el-form-item
        label="商铺名称"
      >
        {{agentname}}
      </el-form-item>
      <el-form-item
        label="支付金额(元)"
      >
        {{amount}}
      </el-form-item>
      <el-form-item
              label="订单号"
      >
        {{order_id}}
      </el-form-item>
      <el-form-item
              label="商品名称"
      >
        {{order_content}}
      </el-form-item>

      <el-form-item
              label="商品图片"
      >

        <div v-if="good_url!=null && good_url!=''">
          <img :src= "getImgUrl()" style="width: 100px;height: 100px; "/>
        </div>
      </el-form-item>
      <el-form-item
              label="下单时间"
      >
        {{insert_time2}}
      </el-form-item>
      <div v-if="type_video=='0'">
      <el-form-item
              label="收货人"
      >
        {{consignee}}
      </el-form-item>
      <el-form-item
              label="收货人电话"
      >
        {{consignee_tel}}
      </el-form-item>
      <el-form-item
              label="收货地址"
      >
        {{province_address}}{{consignee_address}}
      </el-form-item>
      </div>
        <el-form-item
                label="退款货物状态"
        >
          {{refund_state}}
        </el-form-item>
        <el-form-item
                label="退款原因"
        >
          {{refund_reason}}
        </el-form-item>
        <el-form-item
                label="退款描述补充"
        >
          {{refund_remarks}}
        </el-form-item>
        <el-form-item
                label="退款图片"
        >
          <div v-if="refund_img!=null && refund_img!=''">
            <span v-for="item in this.refund_img.split(',')">
                <img :src= "getImgUrl2(item)" style="width: 100px;height: 100px; "/>
              </span>

          </div>
        </el-form-item>



    </el-form>

  </el-dialog>

</template>
<script>
    import * as oneclassService from "@/api/sys/oneclass";
    import util from '@/libs/util.js'
export default {
  name: "oneclassEditForm",
  props: {
      oneclass: Object,
    value: Boolean
  },
  data() {
    return {
        formEdit: true,
      loading: false,
      dialogVisible: false,
        agentname:"",
      type_video:"",
      amount:"",
      order_id:"",
      order_content:"",
      good_url:"",
      insert_time2:"",
      consignee:"",
      consignee_tel:"",
      consignee_address:"",
      province_address:"",
      express_name:"",
      express_no:"",
      refund_img:"",
      refund_state:"",
      refund_reason:"",
      refund_remarks:"",
      form: {

      }
    };
  },
  watch: {
    value(val) {
      this.dialogVisible = val;
    },
    dialogVisible(val) {
      this.$emit("input", val);
    }
  },
  methods: {
    dialogOpen() {
      this.$refs.form.resetFields();
        let form = {};
        this.form = form;
      if (this.oneclass.id) {
       // userService.getUser(this.user.id).then(data => {
        this.type_video=this.oneclass.type_video;
          this.agentname=this.oneclass.agent_name;
        this.amount=this.oneclass.amount;
        this.order_id=this.oneclass.order_id;
        this.order_content=this.oneclass.order_content;
              this.good_url=this.oneclass.good_url;
              this.insert_time2=this.oneclass.insert_time2;
        this.express_name=this.oneclass.express_name;
                this.express_no=this.oneclass.express_no;
        this.consignee=this.oneclass.consignee;
        this.consignee_tel=this.oneclass.consignee_tel;
        this.consignee_address=this.oneclass.consignee_address;
        this.refund_img=this.oneclass.refund_img;
        this.refund_state=this.oneclass.refund_state;
                this.refund_reason=this.oneclass.refund_reason;
                this.refund_remarks=this.oneclass.refund_remarks;
        this.province_address=this.oneclass.province_address;



          this.formEdit = true;
      }
    },
    aaaa(){
      window.open("https://www.kuaidi100.com/","_blank");
    },
      getImgUrl(){
        var good_url=this.good_url;
        if(good_url.match(",")){
          var str = good_url.split(',');
          good_url=str[1];
        }

        return "https://hfqy-1315629620.cos.ap-chengdu.myqcloud.com/"+good_url;
      },
    getImgUrl2(item){


      return "https://hfqy-1315629620.cos.ap-chengdu.myqcloud.com/"+item;
    },
    close() {
      this.$refs["form"].resetFields();
      this.dialogVisible = false;
    }
  }
};
</script>

